<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div>
        <div class="header flex app-ban">
            <router-link to="/"><img src="../assets/newlogo.png" class="logo"></router-link>
            <img src="../assets/mnav.png" class="togglebtn" v-if="!isHovered" @click="toggleblack">
            <img src="../assets/mclose.png" class="togglebtn" v-else @click="toggleblack">

            <div class="nav" :class="{ 'donghua': isHovered }">
                <div>
                    <div class="whitebox" :class="{ 'bigsize': index == 0 }" v-for="(item, index) in arrList"
                        :key="index">
                        <p v-show="item.children" v-for="(items, indexs) in item.children" :key="indexs">
                            <router-link :to="items.link">{{ items.tit }}</router-link>
                        </p>
                        <div class="flex" v-show="index == 0" @click="handleSearch">
                            <p>{{ mobileText.search }}</p><img src="../assets/search.png">
                        </div>
                    </div>
                    <div class="whitebox" v-for="(cur, index) in infos" :key="index">
                        <div class="flex">
                            <p>{{ cur.name }}</p>
                            <p class="open">{{ cur.status === 1 ? `${mobileText.openToday}` : `${mobileText.closedToday}`}}</p>
                            <p>{{ cur.start_time }}-{{  cur.end_time  }}</p>
                        </div>
                    </div>
                    <div class="EN" @click="toggleLang">{{ langLabel }}</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { ref, computed, defineProps, watch } from 'vue';
import { useRouter } from 'vue-router';
import { currentLanguage, setLanguage as setGlobalLanguage } from "../utils/lang";
import { headerLabels, mobileLabels, searchLabels ,imageurl} from "../utils/i18nLabels";
import { searchMethods } from '../utils/searchStore';
import { getExhibitionsInfo } from "../utils/gerData";

const router = useRouter();

const infos = ref([]);

// 获取列表数据
const getExhibitionInfo = () => {
    let queryParams = {
        category_id: 2
    }
    getExhibitionsInfo(queryParams).then(res => {
        console.log(res.data)
        res.data.forEach((item) => {
            item.image = item.image ? imageurl + item.image : undefined
            item.start_time = item?.start_time.slice(0, 4) + '年' + item.start_time?.slice(5, 7) + '月' + item.start_time?.slice(8, 10) + '日'
            item.end_time = item?.end_time.slice(0, 4) + '年' + item.end_time?.slice(5, 7) + '月' + item.end_time?.slice(8, 10) + '日'
            item.created_at = item?.created_at ? item.created_at.slice(0, 4) + '年' + item.created_at.slice(5, 7) + '月' + item.created_at.slice(8, 10) + '日' : ""
            item.updated_at = item?.updated_at ? item.updated_at.slice(0, 4) + '年' + item.updated_at.slice(5, 7) + '月' + item.updated_at.slice(8, 10) + '日' : ""

        })
        infos.value = res.data
    });
}
getExhibitionInfo()

watch(currentLanguage, () => {
    getExhibitionInfo()
})

const arrList = computed(() => {
    const arr = headerLabels.sections.map((section, idx) => ({
        numnum: idx + 1,
        children: section.items.map(it => ({ tit: it.label[currentLanguage.value || 'zh'], link: it.to }))
    }))
    arr.length && arr.forEach((item, index) => {
        if (item.numnum == props.touterNum) {
            arr.splice(index, 1)
            arr.unshift(item);

            return
        }
    })
    arr.unshift({});
    return arr

})
const mobileText = computed(() => {
    const lang = currentLanguage.value || 'zh'
    return {
        search: mobileLabels.search[lang],
        openToday: mobileLabels.openToday[lang],
        closedToday: mobileLabels.closedToday[lang],
    }
})

const langLabel = computed(() => (currentLanguage.value === 'zh' ? 'EN' : '中文'))
function toggleLang() {
    const next = currentLanguage.value === 'zh' ? 'en' : 'zh'
    setGlobalLanguage(next)
}

function handleSearch() {
    // 设置搜索状态
    searchMethods.setShowSearchInput(true);

    // 设置默认搜索关键词（根据当前语言）
    const defaultQuery = searchLabels.placeholder[currentLanguage.value] || searchLabels.placeholder.zh;
    searchMethods.setSearchQuery(defaultQuery);

    // 关闭移动端导航菜单
    isHovered.value = false;

    // 跳转到搜索页面并执行搜索
    router.push({ name: 'SearchResults' });

    // 执行搜索
    searchMethods.performSearch(defaultQuery);
}
const isHovered = ref(false);
function toggleblack() {
    isHovered.value = !isHovered.value;
}
const props = defineProps({
    touterNum: {
        type: Number,
        default: 0
    }
});
// let data = arrList.value
// let obj = {}
// data.length && data.forEach((item, index) => {
//     if (item.numnum == props.touterNum) {
//         obj = item
//     //    data.splice(index, 1)
//         return
//     }
// })
// data.splice(0, 1, obj)
// console.log(obj, 111)
// // data.unshift(obj)
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
    position: fixed;
    width: 100%;
    /* font-family: 'OPPOSansR', sans-serif; */
    height: 80px;
    margin: 0 auto;
    padding: 0 20px;
    background: white;
    box-sizing: border-box;
    z-index: 2;

    .logo {
        width: 60px;
        margin-right: 30px;
    }

    .nav {
        flex: 1;
        justify-content: flex-start;
        position: fixed;
        width: 100%;
        height: 0;
        background: black;
        top: 80px;
        left: 0;
        padding: 0 10px;
        box-sizing: border-box;
        overflow: scroll;
        transition: height .3s ease-in;
    }

    .donghua {
        padding: 0 10px 80px;
        height: 100%;
        transition: height .3s ease-in;
    }

    .togglebtn {
        width: 20px;
        margin-right: 10px;
    }

    .whitebox {
        border-bottom: 2px solid #757575;
        text-align: left;
        padding: 10px 0;

        &:first-child {
            a {
                font-size: 22px !important;
            }

            div {
                opacity: 0.5;
                cursor: pointer;
                transition: opacity 0.3s ease;

                &:hover {
                    opacity: 0.8;
                }

                p {
                    font-size: 22px;
                }

                img {
                    width: 20px;
                }
            }
        }

        p {
            margin: 2px 4px;
            color: #fcfcfc;
            font-size: 16px;

            a {
                color: #fcfcfc;
                font-size: 16px;
            }
        }

        div {
            justify-content: flex-start;
            flex-wrap: wrap;

            p {
                &:nth-child(2) {
                    margin: 2px 8px;
                }

                &.open {
                    color: #d60000;
                }
            }
        }
    }

    .EN {
        text-align: left;
        padding: 14px 0;
        color: #fcfcfc;
        font-size: 16px;
    }
}
</style>